import CollectionView from 'picnic/core/views/Collection';
import ChildView from 'app/cms/carpricechecker/views/modelSelect/Option';
import FormField from 'app/generic/form/views/FormField';


const
	INACTIVE_CLASS = 'is-inactive',
	FILLED_CLASS = 'is-filled'
;

class View extends CollectionView {
	get childviewclass() {
		return ChildView;
	}

	get childtagName() {
		return 'option';
	}

	get template() {
		return ' ';
	}

	render() {
		super.render();

		new FormField({
			el: this.$el,
			context: this.context,
		}).render();

		this.content = this.$el.find('select');
		this.content.empty();

		return this;
	}

	activate() {
		this.$el.removeClass(INACTIVE_CLASS);
	}

	deactivate() {
		this.$el.addClass(INACTIVE_CLASS);
	}

	onReset() {
		this.content.empty();
		this.content.removeClass(FILLED_CLASS);
	}
}

export default View;
